module.exports = __webpack_public_path__ + "img/11088034_L.48641698.png";